export function formatPhoneNumber(phoneString: string) {
    if (!phoneString) {
        return 'Неверный формат номера';
    }

    if (!/^\d{11}$/.test(phoneString)) {
        return 'Неверный формат номера';
    }

    const match = phoneString.match(/^7(\d{3})(\d{3})(\d{2})(\d{2})$/);

    if (match) {
        return `+7(${match[1]})${match[2]}-${match[3]}-${match[4]}`;
    }

    return 'Неверный формат номера';
}
